import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CARDS = [
  {
    title:    'Jogos de Perguntas',
    img:      '/images/jogo-pergunta.jpg',
    fallback: 'linear-gradient(135deg, #1e90ff, #0052cc)',
    icon:     'fas fa-question-circle',
    link:     '/jogo-pergunta',
    label:    'Jogar Agora',
  },
  {
    title:    'Diálogos em Inglês',
    img:      '/images/dialogos.jpg',
    fallback: 'linear-gradient(135deg, #6c3483, #1a5276)',
    icon:     'fas fa-comments',
    link:     '/dialogos',
    label:    'Ouvir Agora',
  },
  {
    title:    'Jogo de Pronúncia',
    img:      '/images/pronuncia.jpg',
    fallback: 'linear-gradient(135deg, #1e3a5f, #0d6efd)',
    icon:     'fas fa-microphone',
    link:     '/pronunciacao',
    label:    'Jogar Agora',
  },
  {
    title:    'Jogos de Cores',
    img:      '/images/color-game.jpg',
    fallback: 'linear-gradient(135deg, #ff6b6b, #ee5a24)',
    icon:     'fas fa-palette',
    link:     '/color-game',
    label:    'Jogar Agora',
  },
  {
    title:    'Treinar Seu Inglês',
    img:      '/images/treinar-ingles.jpg',
    fallback: 'linear-gradient(135deg, #2ecc71, #27ae60)',
    icon:     'fas fa-language',
    link:     '/pratica',
    label:    'Praticar Agora',
  },
  {
    title:    'Dicionário Faminto',
    img:      '/images/dicionario-faminto.jpg',
    fallback: 'linear-gradient(135deg, #9b59b6, #6c3483)',
    icon:     'fas fa-book-open',
    link:     '/dicionario-faminto',
    label:    'Alimentar Agora',
  },
  {
    title:    'Vocabulário',
    img:      '/images/vocabulario.jpg',
    fallback: 'linear-gradient(135deg, #ff6b6b, #c0392b)',
    icon:     'fas fa-spell-check',
    link:     '/vocabulario',
    label:    'Aprender Agora',
  },
  {
    title:    'Espaço Kids',
    img:      '/images/espaco-kids.jpg',
    fallback: 'linear-gradient(135deg, #ffb347, #ff6f61)',
    icon:     'fas fa-child',
    link:     '/espaco-kids',
    label:    'Explorar Agora',
  },
  {
    title:    'Verbos em Inglês',
    img:      '/images/verbos.jpg',
    fallback: 'linear-gradient(135deg, #16213e, #0f3460)',
    icon:     'fas fa-book',
    link:     '/verbos',
    label:    'Estudar Agora',
  },
  {
    title:    'Phrasal Verbs',
    img:      '/images/phrasal-verbs.jpg',
    fallback: 'linear-gradient(135deg, #1e90ff, #0052cc)',
    icon:     'fas fa-link',
    link:     '/phrasal-verbs',
    label:    'Aprender Agora',
  },
  {
    title:    'Falsos Cognatos',
    img:      '/images/falsos-cognatos.jpg',
    fallback: 'linear-gradient(135deg, #e74c3c, #8e44ad)',
    icon:     'fas fa-exclamation-triangle',
    link:     '/falsos-cognatos',
    label:    'Descobrir Agora',
  },
  {
    title:    'Idioms em Inglês',
    img:      '/images/idioms.jpg',
    fallback: 'linear-gradient(135deg, #009688, #00695c)',
    icon:     'fas fa-comment-dots',
    link:     '/idioms',
    label:    'Explorar Agora',
  },
  {
    title:    'Bora Conversar?',
    img:      '/images/conversa-ia.jpg',
    fallback: 'linear-gradient(135deg, #e91e8c, #9c27b0)',
    icon:     'fas fa-robot',
    link:     '/conversa-ia',
    label:    'Conversar Agora',
  },
];

function ActivityCard({ card }) {
  const [imgOk, setImgOk] = useState(true);

  return (
    <a
      href={card.link}
      style={{
        display: 'block',
        borderRadius: 18,
        overflow: 'hidden',
        height: 280,
        position: 'relative',
        textDecoration: 'none',
        boxShadow: '0 6px 24px rgba(0,0,0,0.18)',
        background: imgOk ? '#111' : card.fallback,
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 14px 36px rgba(0,0,0,0.28)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.18)';
      }}
    >
      {imgOk && (
        <img
          src={card.img}
          alt={card.title}
          onError={() => setImgOk(false)}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      )}
      {!imgOk && (
        <div style={{
          position: 'absolute', inset: 0,
          background: card.fallback,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '3.5rem', color: 'rgba(255,255,255,0.25)',
        }}>
          <i className={card.icon} />
        </div>
      )}

      {/* Overlay sempre visível na parte inferior */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to top, rgba(0,0,0,0.78) 0%, rgba(0,0,0,0.1) 55%, transparent 100%)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'flex-end',
        padding: '24px 20px',
        gap: 12,
      }}>
        <i className={card.icon} style={{ fontSize: '2rem', color: 'rgba(255,255,255,0.85)' }} />
        <h3 style={{
          color: '#fff', fontSize: '1.2rem', fontWeight: 700,
          textShadow: '0 2px 8px rgba(0,0,0,0.5)', textAlign: 'center', margin: 0,
        }}>
          {card.title}
        </h3>
        <span style={{
          background: '#ff6f61', color: '#fff',
          padding: '8px 22px', borderRadius: 25,
          fontSize: '0.9rem', fontWeight: 600,
          boxShadow: '0 3px 12px rgba(255,111,97,0.4)',
        }}>
          {card.label}
        </span>
      </div>
    </a>
  );
}

function SubscribeModal({ onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.65)',
      backdropFilter: 'blur(4px)',
      zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}
    onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: '#fff', borderRadius: 20,
        padding: '36px 32px', maxWidth: 440, width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'scaleUp 0.3s ease',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
      }}>
        <button onClick={onClose} style={{
          position: 'absolute', top: 14, right: 18,
          background: 'none', border: 'none',
          fontSize: '1.6rem', color: '#aaa', cursor: 'pointer', lineHeight: 1,
        }}>×</button>

        <div style={{ fontSize: '3rem', marginBottom: 12 }}>🔒</div>
        <h2 style={{ color: '#1a2a4a', fontSize: '1.6rem', fontWeight: 800, marginBottom: 8 }}>
          Assinatura Premium
        </h2>
        <p style={{ color: '#666', marginBottom: 20, fontSize: '0.95rem', fontWeight: 400 }}>
          Para acessar as atividades, você precisa ser aluno ou ter uma assinatura ativa.
        </p>

        <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 8 }}>
          {['Acesso completo a todas as atividades', 'Atualizações semanais de conteúdo', 'Suporte prioritário'].map(b => (
            <li key={b} style={{ display: 'flex', gap: 10, color: '#444', fontSize: '0.92rem', fontWeight: 400 }}>
              <span>✅</span> {b}
            </li>
          ))}
        </ul>

        <div style={{ fontSize: '2.4rem', fontWeight: 800, color: '#1e90ff', marginBottom: 20 }}>
          R$ 29,90 <span style={{ fontSize: '1rem', color: '#999', fontWeight: 400 }}>/mês</span>
        </div>

        <Link
          to="/login?redirectTo=/ecomerce/assinatura"
          style={{
            display: 'block',
            background: 'linear-gradient(135deg, #1e90ff, #16c2fb)',
            color: '#fff', borderRadius: 30,
            padding: '14px 0', fontWeight: 700,
            fontSize: '1.05rem', textDecoration: 'none',
            boxShadow: '0 6px 20px rgba(30,144,255,0.35)',
            transition: 'transform 0.2s',
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
        >
          Assinar Agora
        </Link>
      </div>

      <style>{`
        @keyframes scaleUp {
          from { transform: scale(0.88); opacity: 0; }
          to   { transform: scale(1);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default function Atividades() {
  const { user, loading } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const hasAccess = user?.isAluno === 1 || user?.isAssinante;

  return (
    <div style={{
      minHeight: 'calc(100vh - 66px)',
      background: 'linear-gradient(160deg, #0a1628 0%, #1a2a4a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 24px',
      fontFamily: 'Poppins, sans-serif',
    }}>

      {/* Modal de assinatura */}
      {showModal && <SubscribeModal onClose={() => setShowModal(false)} />}

      <div style={{ width: '100%', maxWidth: 1100 }}>
        <h1 style={{
          color: '#fff', textAlign: 'center',
          fontSize: 'clamp(1.6rem, 4vw, 2.4rem)',
          fontWeight: 800, marginBottom: 8,
          textShadow: '0 2px 16px rgba(0,0,0,0.4)',
        }}>
          <i className="fas fa-gamepad" style={{ marginRight: 12, color: '#1e90ff' }} />
          Atividades
        </h1>
        <p style={{
          color: 'rgba(255,255,255,0.6)', textAlign: 'center',
          marginBottom: 40, fontSize: '1rem', fontWeight: 400,
        }}>
          Escolha uma atividade para praticar seu inglês
        </p>

        {loading ? (
          <div style={{ textAlign: 'center', color: '#fff', fontSize: '1.5rem' }}>
            <i className="fas fa-spinner fa-spin" />
          </div>
        ) : !user ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: 20 }}>
              Faça login para acessar as atividades.
            </p>
            <Link to="/login?redirectTo=/ecomerce/assinatura" style={{
              background: 'linear-gradient(135deg,#1e90ff,#16c2fb)',
              color: '#fff', padding: '12px 32px',
              borderRadius: 30, textDecoration: 'none',
              fontWeight: 700, fontSize: '1rem',
            }}>
              Fazer Login
            </Link>
          </div>
        ) : !hasAccess ? (
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: 20 }}>
              Você precisa de uma assinatura ativa para acessar as atividades.
            </p>
            <button
              onClick={() => setShowModal(true)}
              style={{
                background: 'linear-gradient(135deg,#1e90ff,#16c2fb)',
                color: '#fff', padding: '12px 32px',
                border: 'none', borderRadius: 30,
                fontWeight: 700, fontSize: '1rem',
                cursor: 'pointer', fontFamily: 'Poppins, sans-serif',
              }}
            >
              Ver planos
            </button>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
            gap: 24,
          }}>
            {CARDS.map(card => <ActivityCard key={card.title} card={card} />)}
          </div>
        )}
      </div>
    </div>
  );
}
